import React, { useState } from "react";
import { motion } from "framer-motion";

const CardWithFilter = () => {
  const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
  const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);

  return <motion.div
  initial={false}
  animate={
    isLoaded && isInView
      ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
      : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
  }
  transition={{ duration: 1, delay: 1 }}
  viewport={{ once: true }}
  onViewportEnter={() => setIsInView(true)}
  className="hero__img_container"
>
  <img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1701721170/hero_image_ubtybl_1_cxcogl.png" alt="hand holding a light lamp" onLoad={() => setIsLoaded(true)} />
</motion.div>

}

export default CardWithFilter;